class ProductBundle extends HTMLElement {
  constructor() {
    super();

    this.swiperEl = this.querySelector('.swiper');
    this.isHero = this.classList.contains('component-product-bundle--hero');
    this.slidesCount = this.querySelectorAll('.swiper-slide').length;
  }

  connectedCallback () {
    if (this.isHero) {
      this.slider = new Swiper(this.swiperEl, {
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next--bundle',
          prevEl: '.swiper-button-prev--bundle',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        keyboard: {
          enabled: true,
        }
      });
    } else {
      const spaceBetween = 8;

      this.slider = new Swiper(this.swiperEl, {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: spaceBetween,
        navigation: {
          nextEl: this.swiperEl.parentElement.querySelector('.swiper-button-next--bundle'),
          prevEl: this.swiperEl.parentElement.querySelector('.swiper-button-prev--bundle'),
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        keyboard: {
          enabled: true,
        },
      });

      this.querySelector('.swiper').style.setProperty('--swiper-slide-space', spaceBetween + 'px');
    }
  }
}

customElements.define('component-product-bundle', ProductBundle);
